import { Heading4 } from "@/components/text/Heading4";
import { NormalText } from "@/components/text/NormalText";

export function OutputStep() {
  return (
    <div>
      <Heading4 elementType="h3" className="mb-2">
        Congratulations!
      </Heading4>
      <NormalText elementType="p" className="mb-2 text-sm">
        You've successfully done a conversion! 🚀
      </NormalText>

      <NormalText elementType="p" className="text-sm">
        You can listen to and download your new converted vocals for use in your
        projects.
      </NormalText>
    </div>
  );
}
